import React, { memo, useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';
import { useFilters } from '../../../providers/Filters/useFilters';
import { validFiltersCharge } from '../../../utils/filters';

import { Dropdown } from '../../Dropdown';
import { ButtonFilter } from '../../Buttons';
import { FilterTitle } from '../index';
import Body from './Body';

const params = ['charge_from', 'charge_to'];

const FilterCharge = ({ charge_from, charge_to, filterMethod }) => {
  const { filters, onAddFiltersParams, onDeleteFilter } = useFilters();
  const filterSource = filters[filterMethod];

  const [chargeFrom, setChargeFrom] = useState(charge_from || '');
  const [chargeTo, setChargeTo] = useState(charge_to || '');

  const activeText = useMemo(() => {
    const chargeFromTrimmed = String(chargeFrom !== null && chargeFrom !== undefined ? chargeFrom : '').trim();
    const chargeToTrimmed = String(chargeTo !== null && chargeTo !== undefined ? chargeTo : '').trim();

    if (chargeFromTrimmed === '' && chargeToTrimmed === '') return null;

    if (chargeFromTrimmed !== '' && chargeToTrimmed !== '') {
      return `${chargeFromTrimmed} to ${chargeToTrimmed}`;
    }
    if (chargeFromTrimmed !== '') {
      return `${chargeFromTrimmed} to Max`;
    }
    if (chargeToTrimmed !== '') {
      return `0 to ${chargeToTrimmed}`;
    }

    return null;
  }, [chargeFrom, chargeTo]);

  const onClearFilter = (e) => {
    e.preventDefault();
    onDeleteFilter(params)
  }

  useEffect(() => {
    const isValidChargeFrom = validFiltersCharge(filterSource.charge_from);
    const isValidChargeTo = validFiltersCharge(filterSource.charge_to);

    setChargeFrom(isValidChargeFrom ? filterSource.charge_from : '');
    setChargeTo(isValidChargeTo ? filterSource.charge_to : '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterSource]);

  useEffect(() => {
    onAddFiltersParams(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dropdown.Root>
      <Dropdown.Trigger>
        <ButtonFilter
          name="Charge"
          activeText={activeText}
          onClear={onClearFilter}
        />
      </Dropdown.Trigger>
      <Dropdown.Container
        position="bottom"
        width={240}
      >
        <Dropdown.Header p={16}>
          <FilterTitle>Filter by Charge</FilterTitle>
        </Dropdown.Header>
        <Body
          filterMethod={filterMethod}
        />
      </Dropdown.Container>
    </Dropdown.Root>
  );
}

FilterCharge.defaultProps = {
  filterMethod: 'query',
};

FilterCharge.propTypes = {
  charge_from: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  charge_to: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  filterMethod: PropTypes.string,
};

export default memo(FilterCharge);
